<template>
  <p class="mb-8 text-left text-xl text-white bg-rose-800 p-4 rounded-lg border-rose-500 border-4">
    <p class="mb-2 leading-relaxed">
      Welcome to the new Studi Musicali site.
      <br/>
      The system for accessing articles - <span class="font-bold">reserved for subscribers</span> - has changed. It will no longer be through IP addresses, but will be activated by requesting credentials at the following email:
      <a href="mailto: studimusicali@santacecilia.it" class="underline">studimusicali@santacecilia.it</a>
    </p>
    <p class="mb-2 leading-relaxed">
      The previously used system will remain online at the following
      <a href="https://studimusicaliold.santacecilia.it" class="underline">link</a>
      until April 30, 2025. For 2025, each subscriber will be granted access up to a maximum limit of 10. Subscription methods and conditions for the next year will be communicated by July 31, 2025.
    </p>
  </p>
</template>
